import type { LocaleCode, Money } from '@sshop/domain';

const localeMap: Record<LocaleCode, string> = {
  ge: 'ka-GE',
  en: 'en-US',
};

/**
 * Locale-aware Money formatter. Uses the platform `Intl.NumberFormat` with
 * the currency embedded — no manual concatenation of symbols.
 *
 *   formatMoney({ amount: 1299, currency: 'GEL' }, 'ge') → "1 299 ₾"
 *   formatMoney({ amount: 1299, currency: 'USD' }, 'en') → "$1,299"
 */
export function formatMoney(value: Money, locale: LocaleCode): string {
  return new Intl.NumberFormat(localeMap[locale], {
    style: 'currency',
    currency: value.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value.amount);
}
